<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <div class="card card-small mb-3">
        <div class="card-body d-flex justify-content-center">
					<input type="file" id="file" class="d-none" @change="fileSelected"/>
					<label id="dropZone" for="file" draggable="true" :class="border" v-if="this.image == ''">
						<span class="message">
							<i class="fas fa-cloud-upload-alt" v-if="!this.isLoading"></i>
	            <div v-if="this.isLoading">
	              <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
	            </div>
						</span>
					</label>
					<img :src="this.image" v-if="this.image!==''" class="img-fluid"/>
        </div>
				<div class="alert alert-primary" role="alert" v-if="error">
				  {{ error }}
				</div>   
      </div>
    </div>   
  </div>
</template>

<script>
	export default {
		props: ['message', 'error'],

		data(){
			return {
				border: 'default-border',
				text: 'defaul-text',
				isLoading: false,
				image: ''
			}
		},

		mounted() {
			let dropZone = document.getElementById('dropZone');
			dropZone.addEventListener('dragenter', this.dragEnter);
			dropZone.addEventListener('dragover', this.dragOver);
			dropZone.addEventListener('dragleave', this.dragLeave);
			dropZone.addEventListener('dragend', this.dradEnd);
			dropZone.addEventListener('drop', this.drop);
		},

		methods: {
			fileSelected(e) {
				this.processAFile(e.target.files[0]);
			},

			dragEnter() {
				this.border = 'success-border';
				this.text = 'success-text';
			},

			dragOver(e) {
				e.preventDefault();
			},

			dragLeave() {
				this.border = 'error-border';
				this.text = 'error-text';
			},

			drop(e) {
				e.preventDefault();
				this.processAFile(e.dataTransfer.files[0]);
				this.border = 'default-border';
			},

			processAFile(file) {
				this.$emit('selected', file);
				this.convertToBase64(file);
				this.isLoading = true;
			},

			convertToBase64(file) {
				let reader = new FileReader();
				let that = this;
				reader.onload = e => {
					that.isLoading = false;
					this.image = e.target.result;
				};
				reader.readAsDataURL(file);
			}
		}
	}
</script>